import { useEffect, useRef, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { FaUser, FaSignOutAlt, FaLock } from "react-icons/fa";
import API from "../config/config";
import axiosInstance from "../config/axiosInstance";

const Dropdown = () => {
  const ref = useRef();
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const checkIfClickedOutside = (e) => {
      if (isMenuOpen && ref.current && !ref.current.contains(e.target)) {
        setIsMenuOpen(false);
      }
    };

    document.addEventListener("mousedown", checkIfClickedOutside);
    return () => {
      document.removeEventListener("mousedown", checkIfClickedOutside);
    };
  }, [isMenuOpen]);

  const handleLogout = async () => {
    try {
      if (localStorage.getItem("adminToken")) {
        await axiosInstance.post(API.ADMIN.LOGOUT, {});
      }
    } catch (error) {
      console.error("Error during logout:", error);
    } finally {
      localStorage.removeItem("adminToken");
      localStorage.removeItem("adminRole");
      localStorage.removeItem("adminProfile");
      navigate("/login", { replace: true });
    }
  };

  return (
    <div className="relative inline-block text-left" ref={ref}>
      <button
        onClick={() => setIsMenuOpen((prev) => !prev)}
        className="inline-flex justify-center w-full rounded-full 
                  border border-gray-300 shadow-sm px-2 py-2 bg-white 
                  text-sm font-medium text-gray-700 hover:bg-gray-50 
                  focus:outline-none"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          strokeWidth="1.5"
          stroke="currentColor"
          className="size-6"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M17.982 18.725A7.488 7.488 0 0 0 12 15.75a7.488 7.488 0 0 0-5.982 2.975m11.963 0a9 9 0 1 0-11.963 0m11.963 0A8.966 8.966 0 0 1 12 21a8.966 8.966 0 0 1-5.982-2.275M15 9.75a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z"
          />
        </svg>
      </button>

      {isMenuOpen && (
        <div
          className="origin-top-right absolute right-0 mt-2 w-56 
                    rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5
                    focus:outline-none"
        >
          <div className="py-1">
            <Link
              to="/profile"
              onClick={() => setIsMenuOpen(false)}
              className="flex items-center mb-4 px-2 py-1 text-black hover:text-yellow"
            >
              <FaUser className="mr-3" />
              <span>My Account</span>
            </Link>
            <Link
              to="/change-password"
              onClick={() => setIsMenuOpen(false)}
              className="flex items-center mb-4 px-2 py-0 text-black hover:text-yellow"
            >
              <FaLock className="mr-3" />
              <span>Change Password</span>
            </Link>
            <button
              onClick={() => {
                setIsMenuOpen(false);
                handleLogout();
              }}
              className="flex items-center mb-4 px-2 py-0 text-black hover:text-yellow"
            >
              <FaSignOutAlt className="mr-3" />
              <span>Logout</span>
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default Dropdown;
